var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12C0 5.37256 5.37259 0 12 0C18.6274 0 24 5.37256 24 12ZM5.25 18.75V8.25H8.25V18.75H5.25ZM15.3742 8.25C13.281 8.25 12.921 9.01343 12.75 9.75V8.25H9.75V18.75H12.75V12.75C12.75 11.7773 13.2773 11.25 14.25 11.25C15.1995 11.25 15.75 11.7661 15.75 12.75V18.75H18.75V13.5C18.75 10.5 18.3593 8.25 15.3742 8.25ZM8.25 6C8.25 6.82837 7.57843 7.5 6.75 7.5C5.92157 7.5 5.25 6.82837 5.25 6C5.25 5.17163 5.92157 4.5 6.75 4.5C7.57843 4.5 8.25 5.17163 8.25 6Z",
    fill: "#A2ABBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.f76631f54251f2279b85347b3f902618.svg";
export { ForwardRef as ReactComponent };